/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InputSmall/view.blocks to change it.
import Input from 'DesignSystem/Input/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function InputSmall({
  children,
  viewPath = "/DesignSystem/InputSmall",
  autoComplete,
  autoFocus,
  className,
  disabled,
  innerRef,
  invalidMessage,
  isInvalid,
  label,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  paddingBottom = 7,
  paddingLeft = 8,
  paddingRight = 8,
  paddingTop = 7,
  placeholder,
  textTransform,
  type,
  textAlign,
  value,
  width = 200,
  height = "auto",
  placeholderColor,
  focusedBackgroundColor,
  focusedBorderColor
  
}) {
  return (<React.Fragment
>
<Input
  viewPath={`${viewPath}/Input`}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 className={className}
 disabled={disabled}
 fontSize={14}
 innerRef={innerRef}
 invalidMessage={invalidMessage}
 isInvalid={isInvalid}
 label={label}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 marginTop={marginTop}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 paddingBottom={paddingBottom}
 paddingLeft={paddingLeft}
 paddingRight={paddingRight}
 paddingTop={paddingTop}
 borderBottomLeftRadius={5}
 borderBottomRightRadius={5}
 borderTopLeftRadius={5}
 borderTopRightRadius={5}
 placeholder={placeholder}
 textTransform={textTransform}
 type={type}
 textAlign={textAlign}
 value={value}
 width={width}
 height={height}
 placeholderColor={placeholderColor}
 focusedBackgroundColor={focusedBackgroundColor}
 focusedBorderColor={focusedBorderColor}
 className={className}
/>
{children}
</React.Fragment>)
}